import { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';

export const useLevel1Tag = () => {
  const { t } = useTranslate();
  return useMemo<Record<string, string>>(() => {
    return {
      产品问题: t('bs_71'),
      买家问题: t('bs_72'),
      网页问题: t('bs_73'),
      物流问题: t('bs_74'),
      其他问题: t('bs_75'),
    };
  }, [t]);
};
